import { Text } from "@/components/ui";

/**
 * Celda de solo lectura de un CeCo o una cuenta contable del prorrateo: el código y, debajo, el
 * nombre congelado al asignarlo (snapshot de la línea · no cambia si el catálogo lo renombra).
 * Sin nombre (líneas sin asignar o de un catálogo que ya no lo tiene) solo se ve el código.
 */
export function CodigoConNombre({
  codigo,
  nombre,
  vacio = "—",
  peligro = false,
  mono = false,
}: {
  codigo: string;
  nombre?: string;
  /** Texto cuando no hay código asignado. */
  vacio?: string;
  /** Resalta el texto de "vacío" (p. ej. "Sin cuenta"). */
  peligro?: boolean;
  /** Código en tipografía monoespaciada (resumen compacto del detalle). */
  mono?: boolean;
}) {
  if (!codigo) {
    return (
      <Text size="sm" c={peligro ? "peligro" : undefined} fw={peligro ? 600 : undefined}>
        {vacio}
      </Text>
    );
  }
  return (
    <div className="min-w-0">
      <Text size={mono ? "xs" : "sm"} ff={mono ? "mono" : undefined} className="whitespace-nowrap">
        {codigo}
      </Text>
      {nombre ? (
        <Text size="xs" c="dimmed" truncate title={nombre} className="max-w-[220px]">
          {nombre}
        </Text>
      ) : null}
    </div>
  );
}
